import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import QuickAccessComponent from '@office-start/quick-access-component';
import * as React from 'react';
import { Subscription } from 'rxjs';

import { bootstrapOfficeStartComponent } from '../shared/office-start/bootstrap-office-start-component';
import { initializeFluentIcons } from '../shared/office-start/initialize-fluent-icons';
import { OfficeStartBootstrapperService } from '../shared/office-start/office-start-bootstrapper.service';
import ReactRenderer from '../shared/react/react-renderer';
import { withOfficeFluentProvider } from '../shared/react/withOfficeFluentProvider';
import { ThemingService } from '../shared/services/theming.service';
import { VisualService } from '../shared/services/visual.service';
import { WindowService } from '../shared/services/window.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { ContextService } from '../shared/shared-context/context.service';

@Directive({
    selector: 'ohp-quick-access-react-content'
})
export class QuickAccessReactContentDirective extends ReactRenderer implements OnInit, OnDestroy {
    private readonly visualRefreshSubscription: Subscription;
    private isVisualRefresh: boolean;
    constructor(
        elementRef: ElementRef,
        private readonly capabilitiesService: CapabilitiesService,
        private readonly clientStartupConfigService: ClientStartupConfigService,
        private readonly contextService: ContextService,
        private readonly officeStartBootstrapperService: OfficeStartBootstrapperService,
        private readonly themingService: ThemingService,
        private readonly visualService: VisualService,
        private readonly windowService: WindowService
    ) {
        super(elementRef);

        if (this.capabilitiesService.capabilities.visualBackgroundEnabled) {
            this.visualRefreshSubscription = this.visualService.visualConfigSubscription.subscribe(visualEvent => {
                const shouldRefresh = this.isVisualRefresh !== visualEvent.visualBackgroundEnabled;
                if (shouldRefresh) {
                    this.isVisualRefresh = visualEvent.visualBackgroundEnabled;
                    if (this.rendered) {
                        this.render();
                    }
                }
            });
        }
    }

    public ngOnInit () {
        super.ngOnInit();
        bootstrapOfficeStartComponent(this.officeStartBootstrapperService, this.themingService);
        initializeFluentIcons(this.capabilitiesService, this.contextService, this.clientStartupConfigService);
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
        this.visualRefreshSubscription?.unsubscribe();
    }

    public async getReactElement() {
        let bridgeData;
        if (this.windowService.nativeWindow.ewRcPuid) {
            bridgeData = {
                database: window.ewRcIdb,
                databasePuid: window.ewRcPuid,
                databaseVersionOffset: window.ewClientCacheServerOffset,
                preloadedCacheEntries: window.ewRcPreloadData,
                preloadDuration: window.ewRcPreloadDuration
            };
        }

        const QuickAccessComponentFluent = withOfficeFluentProvider(QuickAccessComponent, { isRefreshEnabled: this.isVisualRefresh });
        return <QuickAccessComponentFluent bridgeData={bridgeData} />;
    }
}
